// src/redux/actions/dropdownActions.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { DROPDOWN, DROPDOWN_PRODUCT, DROPDOWN_WAREHOUSE } from "src/config/apiConfig";
import { DropdownResponse } from "src/models/drop_down/dropdown.model";


export const fetchDropdownThunk = createAsyncThunk(
    'dropdown/fetchDropdown',
    async (dropdownType: string, thunkAPI) => {
        try {
            const accessToken = localStorage.getItem('userToken');
            const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

            const response = await axios.post(
                DROPDOWN,
                { type: dropdownType , Q: "PT. LION SUPER INDO-JABABEKA" },
                { headers }
            );

            if (response.status === 200) {
                return response.data.data;
            } else {
                return thunkAPI.rejectWithValue('Failed to fetch dropdown data');
            }
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.response?.data?.message || 'An error occurred while fetching dropdown data');
        }
    }
);

export const fetchDropdownWarehouseThunk = createAsyncThunk(
    'dropdown/fetchDropdownWarehouse',
    async (query: string, thunkAPI) => {
        try {
            const accessToken = localStorage.getItem('userToken');
            const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

            const response = await axios.post(
                DROPDOWN_WAREHOUSE,
                { q: query },
                { headers }
            );

            if (response.status === 200) {
                return response.data.data;
            } else {
                return thunkAPI.rejectWithValue('Failed to fetch dropdown data');
            }
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.response?.data?.message || 'An error occurred while fetching dropdown data');
        }
    }
);

export const fetchDropdownProductThunk = createAsyncThunk(
    'dropdown/fetchDropdownProduct',
    async (query: string, thunkAPI) => {
        try {
            const accessToken = localStorage.getItem('userToken');
            const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

            const response = await axios.post(
                DROPDOWN_PRODUCT,
                { q: query },
                { headers }
            );

            if (response.status === 200) {
                return response.data.data;
            } else {
                return thunkAPI.rejectWithValue('Failed to fetch dropdown data');
            }
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.response?.data?.message || 'An error occurred while fetching dropdown data');
        }
    }
);